import { CSS } from '@grupoboticario/flora-react'

export const truncatedTextCss: CSS = {
  maxWidth: '150px',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden'
}

export const expandIconCss: CSS = {
  width: '24px',
  height: '24px',
  cursor: 'pointer'
}
